import React from "react";
import {Link} from "react-router-dom";

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-black text-gray-300">
      <div className="max-w-4xl mx-auto px-6 py-16">
        <Link to="/" className="text-purple-400 hover:text-purple-300 mb-8 inline-block">
          &larr; Back to Home
        </Link>

        <h1 className="text-4xl font-bold text-white mb-8">Terms of Service</h1>
        <p className="text-gray-500 mb-8">Last updated: January 26, 2026</p>

        <div className="space-y-8 text-gray-300">
          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">1. Acceptance of Terms</h2>
            <p>
              By accessing or using Exo Entertainment ("Service"), operated by E. x .O. Entertainment Studios
              Inc. ("Company," "we," "us," or "our"), you agree to be bound by these Terms of
              Service. If you do not agree to these terms, please do not use our Service.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">2. Description of Service</h2>
            <p>
              Exo Entertainment provides private entertainment and companion services in Calgary, Alberta. Our offerings include

            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">3. Account Registration</h2>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>You must provide accurate and complete information when creating an account</li>
              <li>You are responsible for maintaining the security of your account credentials</li>
              <li>You must be at least 13 years old to use our Service</li>
              <li>One person may not maintain more than one account</li>
              <li>
                You are responsible for all activities that occur under your account
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">4. User Content</h2>
            <p className="mb-4">
              You retain ownership of content you create using our Service. By using our Service,
              you grant us a limited license to:
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Store and backup your content</li>
              <li>Display your content to you and users you authorize</li>
              <li>Modify content format for compatibility purposes</li>
            </ul>
            <p className="mt-4">
              You are solely responsible for your content and must ensure it does not violate any
              laws or third-party rights.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">5. Third-Party Services</h2>
            <p className="mb-4">
              Our Service integrates with third-party services, including Google. When you connect
              these services:
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>You authorize us to access your data on those services as permitted by you</li>
              <li>Your use of third-party services is subject to their respective terms</li>
              <li>We are not responsible for the availability or functionality of third-party services</li>
              <li>You can disconnect third-party services at any time</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">6. Subscriptions and Payments</h2>
            <p className="mb-4">For paid features of our Service:</p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Subscription fees are billed in advance on a recurring basis</li>
              <li>You can cancel your subscription at any time</li>
              <li>Refunds are available within 30 days of initial purchase</li>
              <li>We reserve the right to change pricing with 30 days notice</li>
              <li>Failed payments may result in service suspension</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">7. Prohibited Conduct</h2>
            <p className="mb-4">You agree not to:</p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Violate any applicable laws or regulations</li>
              <li>Infringe on intellectual property rights of others</li>
              <li>Upload malicious code or attempt to breach security</li>
              <li>Harass, abuse, or harm other users</li>
              <li>Use the Service for spam or unauthorized advertising</li>
              <li>Attempt to reverse engineer our software</li>
              <li>Resell or redistribute the Service without authorization</li>
              <li>Impersonate others or misrepresent your affiliation</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">8. Intellectual Property</h2>
            <p>
              The Service, including its original content, features, and functionality, is owned by
              E. x .O. Entertainment Studios Inc. and is protected by international copyright,
              trademark, and other intellectual property laws. Our trademarks may not be used
              without our prior written consent.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">9. Disclaimer of Warranties</h2>
            <p>
              THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND,
              EITHER EXPRESS OR IMPLIED. WE DO NOT WARRANT THAT THE SERVICE WILL BE UNINTERRUPTED,
              SECURE, OR ERROR-FREE.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">10. Limitation of Liability</h2>
            <p>
              TO THE MAXIMUM EXTENT PERMITTED BY LAW, WE SHALL NOT BE LIABLE FOR ANY INDIRECT,
              INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS OR
              REVENUES, WHETHER INCURRED DIRECTLY OR INDIRECTLY, OR ANY LOSS OF DATA, USE, OR
              GOODWILL.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">11. Termination</h2>
            <p>
              We may terminate or suspend your account and access to the Service immediately,
              without prior notice, for conduct that we believe violates these Terms or is harmful
              to other users, us, or third parties, or for any other reason at our sole discretion.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">12. Changes to Terms</h2>
            <p>
              We reserve the right to modify these Terms at any time. We will provide notice of
              significant changes by posting the new Terms on this page and updating the "Last
              updated" date. Your continued use of the Service after changes constitutes acceptance
              of the new Terms.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">13. Governing Law</h2>
            <p>
              These Terms shall be governed by and construed in accordance with the laws of the
              Province of Saskatchewan, Canada, without regard to its conflict of law provisions.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">14. Contact Us</h2>
            <p>
              If you have questions about these Terms of Service, please contact us at:
            </p>
            <p className="mt-4">
              <strong className="text-white">E. x .O. Entertainment Studios Inc.</strong>
              <br />
              Email: legal@exoentertainment.ca
            </p>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-800">
          <Link to="/privacy" className="text-purple-400 hover:text-purple-300">
            View Privacy Policy &rarr;
          </Link>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
